export const ROUTES = {
  home: '/',
  app: '/*',
  blog: '/blog',
  blogPost: '/blog/:slug',
  privacy: '/privacidade',
  terms: '/termos',
  confirm: '/confirm/:token',
  invite: '/invite/:inviteId',
  checkout: '/checkout',
  billingSuccess: '/billing/success',
  billingCancel: '/billing/cancel',
  login: '/login',
  forgotPassword: '/forgot-password',
  setup: '/setup',
  onboarding: '/onboarding',
  logout: '/logout',
  dashboard: '/dashboard',
  appointments: '/appointments',
  calendar: '/calendar',
  generalCalendar: '/general-calendar',
  patients: '/patients',
  patient: '/patients/:patientId',
  patientSection: '/patients/:patientId/:section',
  users: '/users',
  settings: '/settings',
  news: '/news',
  debug: '/debug',
  migrate: '/migrate',
  loginTest: '/login-test',
  dashboardTest: '/dashboard-test',
  inviteDebug: '/invite-debug',
};
